import React from "react";
import "./styles.css";

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const Switch: React.FC<SwitchProps> = ({ checked, onChange, disabled = false, className = "" }) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      className={`switch ${checked ? "switch--checked" : ""} ${disabled ? "switch--disabled" : ""} ${className}`}
      onClick={handleToggle}
      disabled={disabled}
    >
      <span className="switch-track">
        <span className="switch-thumb" />
      </span>
    </button>
  );
};

export default Switch;

